import { getDatabase } from '../data/db'
import { parseShareOriginal, shareOriginalMetaRecord, shareOriginalKey, type ShareOriginalRecord } from './shareOriginalRecord'

export async function readShareOriginal(noteId: string): Promise<ShareOriginalRecord | null> {
  return parseShareOriginal((await (await getDatabase()).get('meta', shareOriginalKey(noteId)))?.value)
}

export const SHARE_ORIGINAL_EVENT = 'minimany:share-original'

export async function writeShareOriginal(noteId: string, record: ShareOriginalRecord): Promise<void> {
  await (await getDatabase()).put('meta', shareOriginalMetaRecord(noteId, record))
  window.dispatchEvent(new CustomEvent(SHARE_ORIGINAL_EVENT, { detail: { noteId } }))
}
